export const getFileSizeLabel = (size) => {
  if (!size) {
    return '';
  }

  let newSize = size / 1000;

  if (newSize < 1000) {
    return `${newSize.toFixed(1)} KB`;
  }

  newSize = newSize / 1000;

  if (newSize < 1000) {
    return `${newSize.toFixed(1)} MB`;
  }

  newSize = newSize / 1000;
  return `${newSize.toFixed(1)} GB`;
};



// WEBPACK FOOTER //
// ./src/utils/getFileSize.js